import { GOOGLE_MAPS_BASE_URLS } from '../constants';

export const MAX_WAYPOINTS = 9;

export const downsamplePoints = (points, max) => {
  if (!Array.isArray(points) || points.length <= max) {
    return Array.isArray(points) ? points : [];
  }

  const step = (points.length - 1) / (max - 1);
  const sampled = [];
  for (let i = 0; i < max; i += 1) {
    sampled.push(points[Math.round(i * step)]);
  }
  return sampled;
};

const toLatLng = (point) => `${point.latitude},${point.longitude}`;

export const buildRouteMapsUrl = (points) => {
  if (!Array.isArray(points) || points.length === 0) {
    return null;
  }

  if (points.length === 1) {
    return `${GOOGLE_MAPS_BASE_URLS.PLACE}?q=${toLatLng(points[0])}`;
  }

  const trimmed = downsamplePoints(points, MAX_WAYPOINTS + 2);
  const origin = trimmed[0];
  const destination = trimmed[trimmed.length - 1];
  const waypoints = trimmed.slice(1, -1);

  const params = new URLSearchParams({
    api: '1',
    origin: toLatLng(origin),
    destination: toLatLng(destination),
    travelmode: 'driving',
  });
  if (waypoints.length > 0) {
    params.set('waypoints', waypoints.map(toLatLng).join('|'));
  }

  return `${GOOGLE_MAPS_BASE_URLS.DIRECTIONS}?${params.toString()}`;
};
